import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AntCard from 'antd/lib/card';
import colorShape from '../shapes/colorShape';
import './style';

const propTypes = {
  color: colorShape,
  primary: PropTypes.bool,
  shadow: PropTypes.bool,
  noPadding: PropTypes.bool,
  ...AntCard.propTypes,
};

const defaultProps = {
  color: null,
  noPadding: false,
  shadow: false,
  primary: false,
  ...AntCard.defaultProps,
};

function Card({
  children, color, shadow, noPadding, primary, className, ...rest
}) {
  const computedClassName = classNames(
    'bsa-card',
    {
      [`bsa-card__header--${color}`]: color != null,
      'bsa-card--shadow': shadow,
      'bsa-card--no-padding': noPadding,
      'bsa-card__header--scouting-blue': primary && color === null,
    },
    className,
  );

  return (
    <AntCard className={computedClassName} {...rest}>
      {children}
    </AntCard>
  );
}

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;
Card.Meta = AntCard.Meta;

export default Card;
